import $ from 'jquery';

import { Skin } from 'lib/vendor/terrific/Application';

import LegoContainer, {
	DISABLED_VALUES,
} from '../Tc.Module.LegoContainer';

// tslint:disable-next-line: no-duplicate-imports
import type {
	Prices,
	FlavourMobile,
	TrackingInfo,
	LegoContainerConfig,
} from '../Tc.Module.LegoContainer';

interface BundleTotalPrice {
	disabledValues : Record<string, string>,
	mobileConfig : FlavourMobile[] | null,
	selectedFlavours : Record<string, LegoContainerConfig>,
	totalPrice : number;
}

interface InvisibleSkin extends LegoContainer {
	conversionCategory : string;
	conversionDetail : string;
	conversionClass : string;
	prices? : Prices;

	onGetBundleTotalPrice() : void;
}

// tslint:disable-next-line: variable-name
export const Invisible : Skin<LegoContainer, InvisibleSkin> = function Invisible(parent) {
	this.initComponent = function() {
		parent.initComponent.call(this);
		this.sandbox.subscribe('LEGO_CONTAINER', this);
		this.conversionCategory = this.$ctx.data('conversionCategory');
		this.conversionDetail = this.$ctx.data('conversionDetail');
		this.conversionClass = this.$ctx.data('conversionClass');
};

	this.cacheUi = $.noop;
	this.initUi = $.noop;
	this.handleScroll = $.noop;
	this.addEventListeners = $.noop;
	this.updateSummaryPosition = $.noop;

	this.handleDataSuccess = function() {
		if (!this.isEditMode) {
			const deepLinks = this.deepLinkConf;
			if (deepLinks && deepLinks.config.length) {
				this.setInitialOptions(deepLinks.options);
				this.prices = this.calculateTotalPrice(deepLinks.config);
				this.onGetBundleTotalPrice();

				const trackingInfo : TrackingInfo = {
					selectedProducts: deepLinks.config,
				};

				if(this.conversionCategory && this.conversionDetail) {
					trackingInfo.conversionCategory = this.conversionCategory;
					trackingInfo.conversionDetail = this.conversionDetail;
					trackingInfo.conversionClass = this.conversionClass || '';
			}

				setTimeout(() => {
					this.track(trackingInfo);
				}, 500);
			}
		}
	};

	this.onGetBundleTotalPrice = function() {
		const totalPrice = this.prices ? this.prices.totalPrice : 0;
		const bundleTotalPrice : BundleTotalPrice = {
			disabledValues: DISABLED_VALUES,
			mobileConfig: this.mobileConfigData,
			selectedFlavours: this.currentSelection as Record<string, LegoContainerConfig>,
			totalPrice,
		};

		this.fire('bundleTotalPrice', bundleTotalPrice, ['LEGO_CONTAINER']);
	};
};



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/ecommerce/lego/skins/Invisible.ts